import { render, staticRenderFns } from "./AddressInput2.vue?vue&type=template&id=9b1618ec&"
import script from "./AddressInput2.vue?vue&type=script&lang=js&"
export * from "./AddressInput2.vue?vue&type=script&lang=js&"
import style0 from "./AddressInput2.vue?vue&type=style&index=0&id=9b1618ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports